import { ProjectModel } from 'api/dto/Project.dto';
import { PulseProjectApi } from 'api/PulseProjectApi';
import { Resource } from 'model/Resource';

export const STORE_NAME = 'copyPreviousSurvey';

export namespace CopyPreviousSurveyState {
  export type Domain = {
    sourcesResource: Resource<PulseProjectApi.CopySourcesList>;
    previewResource: Resource<ProjectModel>;
    selectedSourceId: number | null;
  };

  export const INITIAL_DOMAIN: Domain = {
    sourcesResource: Resource.createPendingResource(),
    previewResource: Resource.createPendingResource(),
    selectedSourceId: null,
  };
}
